import { ReactNode } from "react";
import styles from "./Toolbar.module.css";

export function Toolbar({ children }: Readonly<{ children: ReactNode }>) {
  return <div className={styles["toolbar"]}>{children}</div>;
}
